export const FormSection = ({
  children,
  columns = 1,
  className
}: {
  children: React.ReactNode;
  columns?: 1 | 2 | 3 | 4;
  className?: string;
}) => {
  const gridCols = {
    1: 'grid-cols-1',
    2: 'md:grid-cols-2 grid-cols-1',
    3: 'md:grid-cols-3 grid-cols-1',
    4: 'md:grid-cols-4 grid-cols-1'
  };

  return <div className={`grid gap-4 ${gridCols[columns]} ${className ?? ''}`}>{children}</div>;
};
